export default {
  home: "Home",
  about: "About",
  products: "Products",
  oemAndodm: "OEM & ODM",
  support: "Support",
  contact: "Contact",
  contactUs: "Contact Us",
  quickQuote: "Quick Quote",
  language: "Language",
  tel: "Tel",
  email: "Email",
  searchProductOnly: 'Search Product Only',
  quickInquiry: 'Quick Inquiry',
  viewDetails: 'View Details',
  search: 'Search',
  news: 'News',
  industry: 'Industry',
  company: 'Company',
  viewMore: 'View More',
  mostViewed: 'Most Viewed',
  careers: 'Careers',
  catalogues: "Catalogues",
  customServices: 'Custom Services',
  faq: 'FAQ',
  recommendProducts: 'Recommend Products',
  download: 'Download',
};
